import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getStoreList } from '@/service/components';

const defaultState = {
  fetching: false,
  error: null,
  query: {},
  data: []
}

const switchPayload = (serviceType, query) => {
  const payload = {
    undefined: () => getStoreList(query),
  }
  return payload[serviceType];
}
const keyConfig = [
  { key: 'default', id: 'id', name: 'name', picture: 'picture', url: 'url' },
]
const defaultKey = { id: 'store_id', name: 'name', picture: 'picture', url: 'url' };

const formatData = ({data, serviceType, dataType, query = {}}) => {
    if (!Array.isArray(data)) return data;
    const fieldMap = keyConfig.find(kc => kc.key === serviceType) || defaultKey;
    const dataTypes = dataType.split(',').map(type => type.trim());
    const result = {};
    dataTypes.forEach(type => {
        result[type] = processSingleDataType({
          data,
          fieldMap,
          dataType: type,
          query});
    });
    return result;
}
const processSingleDataType = ({data, fieldMap, dataType, query}) => {
  switch (dataType) {
    case 'storeOption':
      return data.map(item => ({
        id: `${item.store_id}`,
        value: item.name
      }));
    default: data
  }
}

export const fetchStoreList = createAsyncThunk(
  'store/fetchStoreList',
  async ({serviceType, dataType, query = {}}, {rejectWithValue}) => {
    try {
      const response = await switchPayload(serviceType, query)();
      return {
        data: response.data,
        serviceType,
        dataType,
        query
      }
    } catch (error) {
      return rejectWithValue(error.response?.data || '获取门店列表失败');
    }
  }
)

const storeSlice = createSlice({
  name: 'store',
  initialState: defaultState,
  reducers: {
    resetStoreState: (state, action) => {
      const { serviceType } = action.payload || {};
      if (!serviceType) {
        Object.keys(state).forEach(key => {
          if (Array.isArray(state[key])) {
            state[key] = [];
          }
        });
        state.query = {};
      } else {
        // 重置指定服务类型的数据
        state[serviceType] = [];
        state.query[serviceType] = {};

      }
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchStoreList.pending, (state, action) => {
        const arg = action.meta.arg || {};
        const { serviceType, query = {} } = arg;
        state.fetching = true;
        state.error = null;
        // 根据 serviceType 更新查询参数和数据
        if (serviceType) {
          state.query[serviceType] = query;
          state[serviceType] = [];
        } else {
          state.query = query;
          state.data = [];
        }
      })
      .addCase(fetchStoreList.fulfilled, (state, action) => {
        const { data, serviceType, dataType, query } = action.payload;
        state.fetching = false;
        state.error = null;
        state.data = data;
        state.query = query || {};
      })
      .addCase(fetchStoreList.rejected, (state, action) => {
        state.fetching = false;
        state.error = action.payload;
        state.data = [];
      });
  }
})

export const { resetStoreState } = storeSlice.actions;
export default storeSlice.reducer;